
import {
  CONTENT_WIDTH,
  bottomMarginItemGlobal
} from "../../utils/pdfConstants";
import {
  buildAverageRow,
  applyDifferenceToRows
} from "../../utils/energiaUtils";

export function renderEnergiaTableBlock({ data, content, contentWidth = CONTENT_WIDTH }) {
if (!data || !data.columns || !data.rows) return;


const hasRealData = data.rows.some(row =>
  Object.entries(row).some(([key, val]) => {
    if (key === "Vuosi") return false; // ignore year-only rows
    return val !== "" && val != null && val !== "0";
  })
);

if (!hasRealData) return;

  const { columns, rows, title } = data


  const fontSize = 9;

  // --- COLUMN WIDTHS ---
  const firstColWidth = 50;

  const widths = [firstColWidth, ...Array(columns.length - 1).fill('*')];

  // --- AVERAGE ROW ---
 const processedRows = applyDifferenceToRows(rows, columns);

// 🔥 SITTEN KESKIARVO OIKEIN
const averageRow = buildAverageRow(columns, processedRows);

const rowsWithAverage = averageRow
  ? [...processedRows, averageRow]
  : processedRows;

  // --- TITLE ROW (merged) ---
const titleRow = [
  {
    text: title || "",
    colSpan: columns.length,
    alignment: "center",
    bold: true,
    color: "white",
    fillColor: "#04aa00",
    font: "Lato",
    fontSize: 11,
    margin: [-2, 4, -2, 4], // 👈 KEY FIX
  },
  ...Array(columns.length - 1).fill({})
];

  // --- HEADER ROW ---
  const headerRow = columns.map((col) => ({
    text: col,
    alignment: "center",
    bold: true,
    color: "white",
    fillColor: "#04aa00",
    font: "Lato",
    fontSize,
    margin: [2, 3, 2, 3],
  }));

  // --- BODY ---
 const bodyRows = rowsWithAverage.map((row) => {
  const isAverage = row[columns[0]] === "Keskiarvo";

  return columns.map((col, ci) => {
    const value = row[col] ?? "";

    return {
      text: String(value),
      alignment: "center", // ✅ ALL VALUES CENTERED
      bold: isAverage,
      color: isAverage ? "white" : "black",
      fillColor: isAverage ? "#04aa00" : null,
      font: "Lato",
      fontSize,
      margin: ci === 0 ? [4, 2, 2, 2] : [2, 2, 2, 2],
    };
  });
});

  // --- PUSH TABLE ---
content.push({
  table: {
    headerRows: 2,
    widths,
    body: [
      titleRow,
      headerRow,
      ...bodyRows
    ],
  },


  dontBreakRows: true,
  keepWithHeaderRows: 2,

  layout: {
    hLineWidth: () => 0.3,
    vLineWidth: () => 0,
    hLineColor: () => "#ffffff",
    vLineColor: () => "#ffffff",
    paddingLeft: () => 0,
    paddingRight: () => 0,
    paddingTop: () => 3,
    paddingBottom: () => 3,
  },

  margin: [0, 10, 0, bottomMarginItemGlobal],
});
}